export default __webpack_public_path__ + "static/podioPersonajes-bf87cb942fca074e395a967b9ef1b66e.svg";